import { mapDTO } from '@twistezo/ts-dto-mapper'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { AdUnitBidderAlert } from 'features/globalSetup/api/types/adUnitBidderAlert'
import { AdUnitBidderSlice } from '../types'
import { AdUnitBidderSliceDTO } from './types'

export const fromDTO = (from: AdUnitBidderSliceDTO) =>
  mapDTO<AdUnitBidderSliceDTO, AdUnitBidderSlice>({ from }).transform(
    (adUnitBidderDTO: AdUnitBidderSliceDTO): AdUnitBidderSlice => {
      const {
        csEnabled,
        csRequiredParams,
        domainBidderId,
        fieldAlerts,
        id,
        s2sEnabled,
        s2sRequiredParams,
        updatedAt,
        workspaceBidder: {
          accountType,
          bidder: { name, s2sAvailable },
          bidderCode: code,
          id: workspaceBidderId,
          status: workspaceBidderStatus,
        },
      } = adUnitBidderDTO

      return {
        accountType,
        alerts: alertsFromDTO<AdUnitBidderAlert>(fieldAlerts),
        code,
        csEnabled,
        csRequiredParams,
        domainBidderId,
        id,
        name,
        s2sAvailable,
        s2sEnabled,
        s2sRequiredParams,
        updatedAt: new Date(updatedAt),
        workspaceBidderId,
        workspaceBidderStatus,
      }
    },
  )
